import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  TEXT_VARIANT_STANDARD,
  Text,
} from 'mailup-web-components'

import {
  modalDelStatsContactCancelCallback,
  modalDelStatsContactChangeCallback,
  modalDelStatsContactConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalDelStatsContact'
import {
  modalDelStatsContactCanConfirmState,
  modalDelStatsContactState,
} from 'Pages/RecipientsList/recoil/state/modals'

const ModalDelStatsContact: FC = () => {
  const intl = useIntl()
  const { show, email, isDirty } = useRecoilValue(modalDelStatsContactState)

  const canConfirm = useRecoilValue(modalDelStatsContactCanConfirmState)

  const change = useRecoilCallback(modalDelStatsContactChangeCallback, [])
  const handleCancel = useRecoilCallback(modalDelStatsContactCancelCallback, [])

  const handleConfirm = useRecoilCallback(
    modalDelStatsContactConfirmCallback,
    [],
  )

  const handleEmailInputChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    void change(value)
  }

  const showFeedback = !canConfirm && isDirty

  return (
    <Modal
      show={show}
      data-mu-test="modal-delstats-contact"
      onClose={handleCancel}
      closeOnOverlayClick
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalDelStatsContactTitle',
        })}
      />

      <ModalBody>
        <Flex flexDirection="column" gap="24px">
          <Text variant={TEXT_VARIANT_STANDARD}>
            {intl.formatMessage({
              id: 'Load.RecipientsList.ModalDelStatsContactDescription',
            })}
          </Text>
          <FormElement
            labelFor="email-contact"
            label={intl.formatMessage({
              id: 'Load.RecipientsList.ModalDelStatsContactEmailLabel',
            })}
            required
            variant={showFeedback ? 'danger' : undefined}
            feedback={
              showFeedback
                ? intl.formatMessage({ id: 'Load.MailupCommon.EmptyEmail' })
                : undefined
            }
          >
            <InputText
              id="email-contact"
              onChange={handleEmailInputChange}
              value={email}
              variant={showFeedback ? INPUT_TEXT_VARIANT_DANGER : undefined}
            />
          </FormElement>
        </Flex>
      </ModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleConfirm}
          disabled={!canConfirm}
          data-mu-test="modal-delstats-contact__confirm"
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalDelStatsContact
